<template>
  <div>
    <b-row>
      <b-col>
        <h6 class="text-left">Envoyer un SMS de localisation à un participant</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9">
        <b-form-input v-model="searchFilter" placeholder="Rechercher un participant par nom ou dossard" size="sm"></b-form-input>
        <div class="result_search_favoris" v-if="search_participants.length > 0">
          <div class="result_favoris_item" v-for="(search_fav, index) in search_participants" :key="index">
            <div class="favoris_nation_col">
              <img class="flag_favoris" :src="'https://sportips.fr/live/img/Flags/' + search_fav.nation + '.jpg'" />
            </div>
            <div class="favoris_info_col">
              <p>
                <b>{{ search_fav.dossard }} {{ search_fav.nom }} {{ search_fav.prenom }}</b>
              </p>
              <p>{{ search_fav.course }}</p>
            </div>
            <div class="favoris_add_col">
              <b-button @click="opeModalsendSMS(search_fav)"><b-icon icon="plus"></b-icon> Envoyer un SMS de localisation</b-button>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="3">
        <b-button class="btn inline-btn btn-secondary btn-sm" @click="opeModalsendSMS(null)"><b-icon icon="plus"></b-icon> Envoi de SMS manuel</b-button>
      </b-col>
    </b-row>
    <b-modal v-model="show_modal" busy>
      <h5>Demande de localisation</h5>
      <h6>{{ form_coureur.nom }} {{ form_coureur.prenom }}</h6>
      <p>Un SMS va être envoyé au coureur. Il sera invité à cliquer sur un lien qui permettra de vous envoyer sa position. Vous pourrez ensuite localiser le coureur sur une carte.</p>
      <hr />

      <b-form>
        <b-row>
          <b-col md="6">
            <label for="">Nom du coureur</label>
            <b-form-input v-model="form_coureur.nom" placeholder="Nom du coureur"></b-form-input>
          </b-col>
          <b-col md="6">
            <label for="">Prénom du coureur</label>
            <b-form-input v-model="form_coureur.prenom" placeholder="Prénom du coureur"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="">Dossard du coureur</label>
            <b-form-input v-model="form_coureur.doss" placeholder="Dossard du coureur"></b-form-input>
          </b-col>
          <b-col md="6">
            <label for="">Tel du coureur</label>
            <b-form-input v-model="form_coureur.tel" placeholder="Tel du coureur"></b-form-input>
          </b-col>
        </b-row>
        <p v-if="form_coureur.tel == ''">
          Attention: Le numéro de téléphone du coureur doit être au format <b>*indicatif sans le +* suivi du *numero sans le premier 0*</b><br />
          Exemple de tel valide: <b>33601020304,33701020304,41701020304</b><br />
          Exemple de tel non valide: 0601020304, +330601020304, +33601020304
        </p>
      </b-form>

      <template #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="success" @click="sendSMS()"> Envoyer </b-button>
        <b-button size="sm" variant="danger" @click="cancel()"> Annuler </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      show_modal: false,
      search_participants: [],
      searchFilter: "",
      form_coureur: {
        nom: "",
        prenom: "",
        doss: "",
        tel: "",
      },
    };
  },
  watch: {
    searchFilter() {
      if (this.searchFilter != "") {
        this.fetchInscriptions();
      } else {
        this.search_participants = [];
      }
    },
  },
  methods: {
    async opeModalsendSMS(participant) {
      if (participant == null) {
        this.show_modal = true;
        return;
      }
      let request = await axios.get(this.$store.state.base_url + "/coureur/get.php?id_module=" + this.$store.state.module.id + "&id=" + participant.id + "&pc_course=1");
      if (request && request.data) {
        this.form_coureur.nom = request.data.nom;
        this.form_coureur.prenom = request.data.prenom;
        this.form_coureur.doss = request.data.dossard;
        this.form_coureur.tel = this.reformat_phone(request.data.tel);
      }

      this.show_modal = true;
    },
    async sendSMS() {
      this.show_modal = false;
      let request = await axios.post(this.$store.state.base_url + "/sos/sendSMS.php", {
        id_module: this.$store.state.module.id,
        nom: this.form_coureur.nom,
        prenom: this.form_coureur.prenom,
        doss: this.form_coureur.doss,
        tel: this.form_coureur.tel,
      });
      this.$router.go();
    },
    reformat_phone(phone) {
      phone = phone.replace(/\s/g, "");
      phone = phone.replace(/-/g, "");
      phone = phone.replace(/\./g, "");
      // Handle french phone
      if (phone.startsWith("6") || phone.startsWith("7")) phone = "33" + phone;
      if (phone.startsWith("06") || phone.startsWith("07")) phone = "33" + phone.substring(1);
      if (phone.startsWith("0033")) phone = phone.substring(2);
      phone = phone.replace(/\+/g, "");

      return phone;
    },
    addFavoris(index) {
      this.$emit("addFavoris", this.search_participants[index].id);
      this.searchFilter = "";
      this.search_participants = [];
    },
    buildEndpoint() {
      var url = "/live/get.php?id=" + this.$store.state.module.id + "&course=all";

      if (this.searchFilter != "") {
        url += "&search=" + this.searchFilter;
      }
      return url;
    },
    fetchInscriptions() {
      var _this = this;
      var endpoint = this.buildEndpoint();
      axios.get(this.$store.state.base_url + endpoint).then(function (response) {
        console.log("LIVE -- Fetch list possible favorites ");
        _this.search_participants = response.data.list_participants;
      });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
</style>